export default __webpack_public_path__ + "static/media/480_dummy2016-musikschule01-mobile-de.bd98b728.png";